import React, {useState } from "react";
import {Button, Box } from "@mui/material";
import Header from "../../components/Header.jsx";
import CompanyRegister from "./CompanyRegister.jsx";
import CompanyRegisterTable from "./CompanyRegisterTable.jsx";
import {Link} from "react-router-dom";


export default function FormCompanyContainer (props){

    const [ topButtonShowTableAndForm, setTopButtonShowTableAndForm]=useState("SHOW DATA TABLE");
    const [ showTable, setShowTable]=useState(false);
    const [ showForm, setShowForm]=useState(true);
    
    const handleButtonClick = () =>{
        if(showForm===true){
          setShowForm(false);
          setShowTable(true);
          setTopButtonShowTableAndForm("SHOW FORM");
        }
        else{
          setShowForm(true);
          setShowTable(false);
          setTopButtonShowTableAndForm("SHOW DATA TABLE");
        }
    }

    return(
        <Box m="20px">
          <Header title="CREATE COMPANY" subtitle="Create a New Company" />
          <Button onClick={handleButtonClick} type="Submit" 
          name="topButtonShowTableAndForm" color="secondary" variant="contained">
            {topButtonShowTableAndForm}
          </Button>
          
          <div sx={{height: "1800px"}}>
          { showForm && (<CompanyRegister />)}
          { showTable && (<CompanyRegisterTable />)}
          </div>
          
          <Button>
          <Link to="/systemUsers">USERS</Link>
          </Button>
          
        </Box>
    )

}